import React from "react";
import "antd/dist/antd.min.css";
import axios from '../axios';
import {Table, Button, Input, Space, Tag} from "antd";
import { SearchOutlined, LockFilled } from '@ant-design/icons';
import { useState, useCallback, useEffect, useRef} from "react";

import StockPerformance from "../StockPerformance";

import { useMediaQuery } from 'react-responsive';

const TeamOnlyTable = (props) => {


  //const isTabletOrMobile = useMediaQuery({maxWidth:640});
  const isLarge = useMediaQuery({minWidth:900});
  //const isMobile = useMediaQuery({maxWidth:500});
  const isXSmall = useMediaQuery({maxWidth:575});

  const [chartView, setChartView] = useState(false);
  const [chartEquity,setChartEquity] = useState(-1);
  const [chartName,setChartName] = useState("");
  const [tablePagination,setTablePagination] = useState({current:1, pageSize:50});
  const tablePaginationRef = useRef(tablePagination);


  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm) => {
    console.log("handle search");
    console.log(selectedKeys);
    confirm();
  };
  const handleReset = (clearFilters,setSelectedKeys,confirm) => {
    console.log("handle reset ")
    clearFilters();
    setSelectedKeys([]);
    confirm();
  };

  const teamSearchProps = {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search Name`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters,setSelectedKeys,confirm)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record['name'].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    }
  };

  const goToStockChart = (e,record) => {
    console.log(record.ent_id);
    console.log(record.ent_id);
    setChartView(true);
    setChartEquity(record.equity_id);
    setChartName(record.name)
    props.showStockPerformance(record.equity_id,record.name);
  }

  var columns = [

    {
      title: "Seed",
      dataIndex: "seed",
      key: "seed",
      width: '50px',
      sortDirections: ['descend','ascend'],
      sorter: isLarge ? (a, b) => {
        if (a.seed>b.seed){
          return -1;
        }
        else {
          return 1;
        }
      } : null,
      hidden: !(props.sport==="NCAAM")
    },
    {
      title: !isXSmall ? "Team" : "Tm",
      dataIndex: "name",
      key: "team",
      sortDirections: ['descend','ascend'],
      width: isLarge ? 'auto' :  '15%',
      sorter: isLarge ? (a, b) => {
        if (a.team>b.team){
          return -1;
        }
        else {
          return 1;
        }
      } : null,
      ...teamSearchProps

    },
    {
      title: "",
      responsive: ['md'],
      render : (record) => (
        <Button onClick={(e) => {goToStockChart(e,record)}}>See Chart</Button>
      )
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      width: isLarge ? 'auto' :  '15%',
      defaultSortOrder: 'descend',
      sortDirections: ['descend','ascend'],
      sorter:  (a, b) => a.price - b.price
    },
    {
      title: "Weekly Change",
      dataIndex: "change",
      key: "change",
      responsive: props.transact ? ['sm'] : null,
      sortDirections: ['descend','ascend'],
      sorter:  (a, b) => a.change - b.change,
      render : (text,record) => (
        record.change ? (record.change>0 ? <Tag color='green'>{text}%</Tag> : (record.change<0 ? <Tag color='red'>{text}%</Tag> : <Tag>{text}%</Tag>)) : <span>-</span>

      ),
      hidden: props.hist
    },
    {
      title: "YTD Change",
      dataIndex: "YTDchange",
      key: "YTDchange",
      responsive: ['sm'], //small appears at 575px
      sortDirections: ['descend','ascend'],
      sorter:  (a, b) => a.YTDchange - b.YTDchange,
      render : (text,record) => (
        record.YTDchange ? (record.YTDchange>0 ? <Tag color='green'>{text}%</Tag> : (record.YTDchange<0 ? <Tag color='red'>{text}%</Tag> : <Tag>{text}%</Tag>)) : <span>-</span>

      )
    },
    {
      title: "Dividend",
      dataIndex: "dividend",
      key: "dividend",
      sortDirections: ['descend','ascend'],
      sorter:  (a, b) => a.dividend - b.dividend,
      responsive: ['sm'],
      hidden: props.hist
    },
    {
      title: "Proj. Earnings",
      dataIndex: "growth",
      key: "growth",
      sortDirections: ['descend','ascend'],
      sorter:  (a, b) => a.growth - b.growth,
      responsive: ['sm'],
      hidden: props.hist
    },
    { //buy columns
      title: props.transact===1 ? "Buy Shares" : "Add",
      dataIndex: "key",
      key: "key",
      responsive: ['sm'],
      render : (text,record) => (
        !record.restricted ? <Button onClick={(e) => {props.purchaseCallback(e,record)}} >{props.transact===1 ? "Buy Shares" : "Add"}</Button> : <LockFilled />
      ),
      hidden: props.transact===0
    },
    { //buycolumn mobile
      title: props.transact===1 ? "Buy" : "Add",
      dataIndex: "key",
      key: "key",
      responsive: ['xs'],
      render : (text,record) => (
        !record.restricted ? <Button onClick={(e) => {props.purchaseCallback(e,record)}} >{props.transact===1 ? "Buy" : "Add"}</Button> : <LockFilled />
      ),
      hidden: props.transact===0
    }

  ].filter(item=>!item.hidden);


  const [isErr,setIsErr] = useState(false);
  const [loading,setLoading] = useState(true);
  const [marketData,setMarketData] = useState([]);
  const [tableColumns,setTableColumns] = useState(columns);
  //console.log(props);

  const udpateTableColumns = () => {

    setTableColumns(columns);
  }

  const fetchData =  useCallback(async() => {

    var data = [];
    setMarketData([]);
    try {
      console.log("get team market response");
      let url = props.sport;
      console.log(props.type);
      console.log(props.sport);
      if (props.type==="Playoffs") {
        //console.log("here in playoffs");
        url = url + "Playoffs";

      }
      url = url + "market";
      if (props.sport==="NCAAM" && props.type==="Playoffs"){
        url = "NCAAMarchMadness";
      }
      if(props.hist){
        url = url + "History";
      }
      console.log(url);
      const res = await axios.get('/getmarket/'+ url);

      console.log(res.data); //debugger
      for (let i=0; i<res.data.length; ++i){
        var obj;
        var record = res.data[i];
        var YTDchange;
        var change;
        //console.log(record);
        if (record?.prevprice){
          //console.log(record.prevprice)
          change = (100*(Number(record.price)-Number(record.prevprice))/Number(record.prevprice)).toFixed(2);
        }
        else {
          change = null;
        }
        if (record?.origprice){
          YTDchange = (100*(record.price-record.origprice)/Number(record.origprice)).toFixed(2);
        }
        else {
          YTDchange = null;
        }
       // console.log(change)
        if (record?.player_id){
          //this should not happen in team only table
        }
        else {
          //console.log(record);
          obj = {
            name: isLarge ? record.city + " " + record.nickname : record.abbrev,
            position: "TEAM",
            team: record.city + " " + record.nickname,
            seed: record.ranking,
            teamabbrev: record.abbrev,
            price: record.price,
            dividend: record.dividend,
            equity_id: record.equity_id,
            ent_id: record.team_id,
            key: record.equity_id,
            restricted: record.restricted,
            change: change,
            YTDchange: YTDchange,
            growth: (record.price - record.dividend).toFixed(2)
          }

        }
        if (obj.restricted){
          obj.name = obj.name + "*";
        }
        data.push(obj)
      }
      //data.sort()
      setLoading(false);
      console.log(data);
      setMarketData(data);

    
    }
    catch (err) {
      console.log(err);
      setIsErr(true);
      setLoading(false);
    }
  },[props.type,props.hist,isLarge,props.sport]);

  useEffect( () => {
    console.log("here in team table use effect");

    udpateTableColumns();
    fetchData();
  }, [fetchData,props.transact,props.type]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect( () => {
    udpateTableColumns();
  }, [isXSmall,isLarge]);  // eslint-disable-line react-hooks/exhaustive-deps

  const handleTableChange = (pagination,filters,sorters,extra) => {
    console.log("handle table change");
    //console.log(pagination);
    console.log(sorters)
    console.log(extra)
    setTablePagination(pagination);
    tablePaginationRef.current = pagination;
  }

  const backFunction = () => {
    setChartView(false);
    setChartEquity(-1);
    setChartName("")
    props.backFunction()
  }

  const expandableRows = {
    expandedRowRender: (record) => (
      <span>
        <div>
         {props.transact ? <span>Weekly Change: {record.change ? (record.change>0 ? <Tag color='green'>{record.change}%</Tag> : (record.change<0 ? <Tag color='red'>{record.change}%</Tag> : <Tag>{record.change}%</Tag>)) : <span>-</span>}</span> : <span></span>}
         YTD Change: {record.YTDchange ? (record.YTDchange>0 ? <Tag color='green'>{record.YTDchange}%</Tag> : (record.YTDchange<0 ? <Tag color='red'>{record.YTDchange}%</Tag> : <Tag>{record.YTDchange}%</Tag>)) : <span>-</span>}
        </div>
        <div>
          Dividend: ${record.dividend}  Proj. Earnings: ${record.growth}
        </div>
        {/*<div>
        <Button onClick={(e) => {goToStockChart(e,record)}}>See Chart</Button>
    </div>*/}
        {<div>
          <StockPerformance eqID={record.equity_id} name={record.name}  mobile={true} hist={props.hist}/>
        </div>}
      </span>
    ),
    rowExpandable: (record) => isXSmall
  }

    return (
      <span>
          {!chartView && <div >
          {!isErr &&
            <span><text>Trading is halted for players/teams indicated with a *</text>
          <Table
            dataSource={marketData}
            columns={tableColumns}
            loading={loading}
            pagination={tablePagination}
            onChange={handleTableChange}
            expandable={isXSmall ? expandableRows: null}
            size= {isLarge ? "large" : "small"}

          /></span>}
          {isErr &&
          <p>Server Error. Failed to get market data.</p>}
        </div>}
        {chartView && <StockPerformance backFunction={backFunction} eqID={chartEquity} name={chartName}  mobile={false} hist={props.hist}/>}
      </span>
    );

}


export default TeamOnlyTable